/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { TutorAIDocumentStatus } from "../types/TutorAIDocumentStatus.ts";

/**
 * @description 1 = Pending | 2 = Imported | 3 = OutOfSync |
 */
export const tutorAIDocumentStatusSchema = z
  .union([z.literal(1), z.literal(2), z.literal(3)])
  .describe(
    "1 = Pending | 2 = Imported | 3 = OutOfSync | ",
  ) as unknown as ToZod<TutorAIDocumentStatus>;
